import * as validators from './../../conf/validators';

export const validate = (value, rules) => {
    var result = {
                    isValid:true,  
                    errorMessage: ''
                 };
 
    for (let key in rules)
    {
        if(key === 'required' && rules[key][0] === false && value === '' )
        {
            //in this case we don't need to check the other rules
            break;
        }
        var fn = validators[key];
        if(typeof fn === 'function' && result['isValid'])
        {
            // we use call routine to be able to call the corresponding function, syntax is as follow : fn.call(this, [arg1,..., argN] )
            result['isValid'] = fn.call(validators, value, rules[key][0]);
            result['errorMessage'] = !result['isValid'] ? rules[key][1] : '';
            
        }        
    }

    return result;
}


// WEBPACK FOOTER //
// ./src/utils/form/validation.js